<div
  class="ui-re"
  [class.ui-re--invalid]="invalid()"
  [class.ui-re--disabled]="disabled()"
  [class.ui-re--readonly]="readonly()"
>
  <!-- Header: label + badge -->
  @if (label()) {
    <div class="ui-re__header">
      <label class="ui-re__label" [attr.for]="inputId()">
        {{ label() }}
      </label>
      @if (showRequirement()) {
        <span
          class="ui-re__requirement"
          [class.ui-re__requirement--error]="invalid() && required()"
          aria-hidden="true"
        >
          {{ requirementText() }}
        </span>
      }
    </div>
  }

  <!-- Envoltorio del editor Quill -->
  <div
    class="ui-re__wrapper"
    [class.ui-re__wrapper--invalid]="invalid()"
    [class.ui-re__wrapper--disabled]="disabled()"
    [class.ui-re__wrapper--readonly]="readonly()"
    [style.--re-min-height]="minHeight()"
    [style.--re-max-height]="maxHeight() ?? 'none'"
  >
    <!-- Quill monta toolbar + editor aquí -->
    <div
      #editorContainer
      [id]="inputId()"
      [class.ui-re__quill--locked]="isLocked()"
    ></div>
    @if (isLocked()) {
      <div class="ui-re__static" [innerHTML]="value()"></div>
    }
  </div>

  <!-- Mensaje de error -->
  @if (message() && invalid() && showMessage()) {
    <p
      class="ui-re__message"
      [id]="messageId()"
      role="alert"
    >
      {{ message() }}
    </p>
  }
</div>
